import { z } from "zod";
import { PublicWebPaywallSchema } from "./webPaywall";
import { PublicWebPaywallTriggerSchema } from "./webPaywallTrigger";
// GET /api/v1/web/static_config
export const WebStaticConfigResponseSchema = z.object({
    ts: z.number(),
    triggers: z.array(PublicWebPaywallTriggerSchema),
    paywalls: z.array(PublicWebPaywallSchema)
});
// POST /api/v1/web/checkout
export const WebCheckoutSessionRequestSchema = z.object({
    webProductId: z.number(),
    stripePriceId: z.string(),
    currentUrl: z.string(),
    webPaywallIdentifier: z.string().optional(),
    webPaywallTriggerIdentifier: z.string().optional(),
    appUserId: z.string().optional(),
    stripeCustomerId: z.string().optional()
});
export const WebCheckoutSessionResponseSchema = z.object({
    sessionId: z.string(),
    url: z.string()
});
// GET /api/v1/web/checkout/:checkoutId
export const WebCheckoutSessionPollResponse = z.object({
    payment_status: z.enum([
        "paid",
        "unpaid",
        "no_payment_required"
    ]),
    status: z.enum([
        "open",
        "complete",
        "expired"
    ]),
    customer_id: z.string().optional()
});
// GET /api/v1/web/stripe_user/:stripeUserId/subscription_active
export const WebStripeUserResponseSchema = z.object({
    subscriptions: z.array(z.object({
        stripe_product_rank: z.number(),
        active: z.boolean(),
        end_date: z.number().optional()
    }))
});
// POST /api/v1/web/checkout/:checkoutId/redeem
export const WebCheckoutSessionRedeemResponseSchema = z.object({
    stripeCustomerId: z.string().optional()
});
